import { isDevRuntime } from '../../constants/devControls';
import {
  isActiveMatchRoute,
  isCollectionScannerRoute,
  isLocalMatchRoute,
} from '../layout/routeChrome';

let openProfileSetup: (() => void) | null = null;

/** Wired by the profile-setup host so the DEV drawer can open the prompt. */
export function registerProfileSetupOpener(open: (() => void) | null): void {
  openProfileSetup = open;
}

/** Opens the new-player prompt for the signed-in account, ignoring signup gates. */
export function devForceShowProfileSetup(): void {
  if (!isDevRuntime()) return;
  openProfileSetup?.();
}

/**
 * Whether a brand-new account should see the handle + photo prompt.
 * Dev force-open bypasses this and is handled by the host.
 */
export function shouldOfferProfileSetup(opts: {
  profileSetupPending: boolean;
  signInOpen: boolean;
  pathname: string;
  guestPromptActive: boolean;
}): boolean {
  if (!opts.profileSetupPending) return false;
  if (opts.signInOpen) return false;
  if (opts.guestPromptActive) return false;
  if (opts.pathname === '/profile' || opts.pathname.startsWith('/profile/')) return false;
  if (isCollectionScannerRoute(opts.pathname)) return false;
  if (isActiveMatchRoute(opts.pathname) || isLocalMatchRoute(opts.pathname)) return false;
  return true;
}
